import * as announcementService from '../../services/announcement.service';

let cache = null;

export const peekAnnouncementClientCanView = () => cache === true;

export const getAnnouncementClientCanView = () => {
  if (cache !== null) return Promise.resolve(cache);
  return announcementService.getSettings()
    .then((s) => {
      const settings = s && s.data ? (s.data.data ? s.data.data : s.data) : null;
      cache = settings ? settings.clientcanview === true : false;
      return cache;
    })
    .catch(() => {
      cache = false;
      return cache;
    });
};
